module.exports = __webpack_public_path__ + "assets/img/ExtractOne_btn.1aa8b09c.png";